import Popper from 'popper.js'
import throttle from '../throttle'

export const PopperMixin = (toggle = 'toggle', options = {}) => {
  return {
    props: {
      placement: {
        type: String,
        default: options.placement || 'top',
        valid: [
          'top',
          'right',
          'bottom',
          'left'
        ]
      },
      shift: {
        type: String,
        default: options.shift || null,
        valid: [
          'start',
          'end'
        ]
      }
    },
    computed: {
      popper () {
        return this[toggle] || {}
      }
    }
  }
}

export const PopperToggleMixin = (target = 'target') => {
  return {
    computed: {
      placement () {
        if (this.popper) {
          return this.popper.data && this.popper.data.placement.split('-')[0]
        }
      },

      placementClass () {
        if (this.popper) {
          return this.placement && `is-${this.placement}`
        }
      },

      shift () {
        if (this.popper) {
          return this.popper.data && this.popper.data.placement.split('-')[1]
        }
      },

      style () {
        if (this.popper) {
          return this.popper.data && this.popper.data.styles
        }
      },

      arrowStyle () {
        if (this.popper) {
          return this.popper.data && this.popper.data.offsets.arrow
        }
      },

      boundaries () {
        if (this.popper) {
          const {boundaries} = this.popper.modifiers.find(m =>
            m.name === 'preventOverflow'
          )

          return boundaries && {
            ...boundaries,
            width: boundaries.right - boundaries.left,
            height: boundaries.bottom - boundaries.top
          }
        }
      }
    },
    methods: {
      pop () {
        if (!this[target]) {
          return
        }

        const {placement, shift, $refs} = this[target]

        const update = data => {
          this.$set(this.popper, 'data', {
            placement: data.placement,
            styles: {
              transform: data.styles.transform,
              position: data.styles.position,
              top: `${data.styles.top}px`,
              left: `${data.styles.left}px`
            },
            offsets: {
              arrow: data.offsets.arrow && {
                top: `${data.offsets.arrow.top}px`,
                left: `${data.offsets.arrow.left}px`
              },
              target: {
                width: `${data.offsets.reference.width}px`
              }
            }
          })
        }

        this.popper = new Popper(
          this.$el,
          this[target].$el,
          {
            placement: placement + (shift ? '-' + shift : ''),
            modifiers: {
              arrow: $refs.arrow && {
                element: $refs.arrow
              },
              applyStyle: {
                enabled: false
              },
              preventOverflow: {
                padding: 0
              }
            },
            onCreate: update,
            onUpdate: update
          }
        )

        this.observer = new MutationObserver(throttle(this.popper.update))

        this.observer.observe(this[target].$el, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        })
      },

      unpop () {
        if (this.popper) {
          this.popper.destroy()
        }

        if (this.observer) {
          this.observer.disconnect()
        }
      }
    },
    data () {
      return {
        popper: null
      }
    },
    destroyed () {
      this.unpop()
    }
  }
}
